import { render, staticRenderFns } from "./Advise3ds.vue?vue&type=template&id=7079ab44&"
import script from "./Advise3ds.vue?vue&type=script&lang=js&"
export * from "./Advise3ds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports